// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__EJaP3","singleAction":"styles_singleAction__F8hh+","ui-spin":"styles_ui-spin__uk03E"};